import React from 'react';
const AboutUs=()=>{
    return(
        <div style={{
            height:'40vw',
            paddingTop:100,
            paddingRight:10,
            paddingLeft:10
        }}>
            <div style={{
                boxShadow:'0 4px 8px 0 rgba(0,0,0,0.2)',
                transition:'0.3s',
                padding:10,
                borderRadius:20
            }}>
                <span>SuperSeva Services Private Limited, founded in the year 2000, is headquartered in Bangalore. For nearly 2 decades now, SuperSeva has been providing comprehensive Enterprise-centric services to help organizations conduct business more effectively.</span>
            </div>
            <div style={{
                boxShadow:'0 4px 8px 0 rgba(0,0,0,0.2)',
                transition:'0.3s',
                padding:10,
                borderRadius:20,
                marginTop:10

            }}>
                <span>Today, SuperSeva is the leader in the Enterprise Support service industry in India serving at over 300 client locations across the country. SuperSeva, designs, builds and operates technology-enabled business support solutions for fortune 500 companies. We also provide a complete range of enterprise support services by leveraging our domain and business expertise and strategic alliances with various business partners.</span>
            </div>
            <div style={{
                boxShadow:'0 4px 8px 0 rgba(0,0,0,0.2)',
                transition:'0.3s',
                padding:10,
                borderRadius:20,
                marginTop:10
            }}>
                <span>With complete focus on delivering excellent client service and a quality management system in place, backed by the ISO 9001:2015 certification, it’s no wonder we are the vendor of choice for virtually every major organization today. SuperSeva is based in Bangalore and has a PAN India presence with 7 offices and presence in 35+ locations.</span>
            </div>
        </div>

    )
}
export default AboutUs